/**
 * @component {"type":"AttemptCountPerVisit","version":"1.0"}
 */

define('task-match-pair',['knockout', 'helpers', 'utils', 'isotope', 'dragula', 'user-answers'], function(ko, helpers, utils, Isotope, dragula, UserAnswers) {
    'use strict';

    return function(parentVM, dataContext, taskVM) {
        var self = this,
            matchPair,
            matchPairDraggable,
            iso,
            answers = {},
            userAnswers = new UserAnswers(),
            entityVM = parentVM.entity,
            trainingVM = parentVM.training,
            userID = dataContext.userID,
            timeoutID,
            timeoutDraggableID;

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.getVersion = function() {
            var task = dataContext.task || {},
                matchPairs = task.matchPairs || {},
                renderMode = matchPairs.renderMode || '';

            return (renderMode && renderMode.toLowerCase() ===  'clickable') ? true : false;
        };

        self.duration = ko.observable(150);

        self.userAttempts = ko.observable(0);

        self.updateAttempts = function(count) {
            count = count || 0;
            count++;

            self.userAttempts(count);

            if (dataContext.localStorage && userID) {
                (function () {
                    window.localStorage.setItem('attempts-' + userID + '-' + entityVM.ID(), count);
                })();
            }
        }

        // Attempt Count Per Visit
        self.ACPV = ko.computed(function() {
            var entityContent = entityVM.entityContent(),
                ID = entityContent.ID,
                content = helpers.component.getContent(entityContent.componentsJSON, 'AttemptCountPerVisit');

            if (dataContext.localstorage && userID) {
                var userAttempts = 0;

                userAttempts = window.localStorage.getItem('attempts-' + userID + '-' + ID) || 0;
                self.userAttempts(parseInt(userAttempts));
            }

            return (content.count) ? parseInt(content.count) : 0;
        });

        self.computedQuestions = ko.computed(function() {
            var entityContent = entityVM.entityContent(),
                res = [],
                userAnswer,
                computedQuestions = trainingVM.computedQuestions(),
                computedAnswers = trainingVM.computedAnswers(),
                getLabel = function(ID, arr) {
                    arr = arr || [];

                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].id === ID) {
                            return arr[i].text;
                        }
                    }

                    return '';
                };

            if (entityContent.typeID !== 16) {
                return res;
            }

            if (taskVM.isEnabled()) {

                computedQuestions.forEach(function(computedQuestion, i) {
                    res.push({
                        dataID: '',
                        questionID: computedQuestion.id,
                        questionLabel: computedQuestion.text,
                        answerID: computedAnswers[i].id,
                        answerLabel: computedAnswers[i].text,
                        cssClass: ''
                    })
                });

            } else {
                userAnswer = userAnswers.getUserAnswer(entityContent.ID);

                if (!userAnswer.answers) {
                    return res;
                }

                userAnswer.answers.forEach(function(answer) {
                    res.push({
                        dataID: answer.answerId,
                        questionID: answer.questionId,
                        questionLabel: getLabel(answer.questionId, computedQuestions),
                        answerID: answer.answerId,
                        answerLabel: getLabel(answer.answerId, computedAnswers),
                        cssClass: 'match-option-answered match-option-grouped ' + trainingVM.colClass('f-col-match-pair', null, answer.questionId)
                    });
                });
            }

            return res;

        }).extend({deferred: true});

        self.orderno = function(i, type, cols) {
            var isEnabled = taskVM.isEnabled();

            cols = cols || (utils.getLayout() === 'js-cols') ? true : false;

            switch(type) {
            case 'header':
                return (cols || !isEnabled) ? i * 1 : i * 50;
            case 'left':
                return 2*i + 10;
            case 'right':
                return (cols || !isEnabled) ? (2*i + 11) : (2*i + 51);
            }

            return 0;
        }

        function MatchPair(options) {
            options = options || {};

            this.container = options.container || document;

            this.left = null;
            this.right = null;

            this.ID = null;

            this.answered = 'match-option-answered';
            this.checked = 'match-option-checked';
            this.grouped = 'match-option-grouped';
        }

        MatchPair.prototype.getParent = function(target) {
            if (target && target.classList && target.classList.contains('js-match-option')) {
                return target;
            }

            if (!target.parentNode) {
                return null;
            }

            return this.getParent(target.parentNode);
        };

        MatchPair.prototype.setHeight = function(node, height) {
            var inner = (node) ? node.querySelector('.match-option-label') : null;

            if (inner) {
                inner.style['min-height'] = height + 'px';
            }
        };

        MatchPair.prototype.resize = function(left, right) {
            var cols = (utils.getLayout() === 'js-cols') ? true : false,
                leftH,
                rightH;

            left = left || this.left;
            right = right || this.right;

            if (!cols) {
                return;
            }

            this.setHeight(left, 0);
            this.setHeight(right, 0);

            leftH = left.offsetHeight;
            rightH = right.offsetHeight;

            if (leftH > rightH) {
                this.setHeight(right, leftH);
            } else if (leftH < rightH) {
                this.setHeight(left, rightH);
            }
        };

        MatchPair.prototype.group = function() {
            var nodes = document.querySelectorAll('.' + this.grouped),
                no = 10000;

            for (var i = 0; i < nodes.length; i++) {
                no = Math.min(no, nodes[i].dataset.orderno);
            }

            if (no) {
                no = parseInt(no/100);
                no = (no - 1) * 100;
            }

            this.resize();

            this.left.dataset.orderno = no;
            this.left.dataset.id = this.right.id;
            this.left.classList.remove(this.checked);
            this.left.classList.add(this.grouped);

            this.right.dataset.orderno = no + 1;
            this.right.dataset.id = this.left.id;
            this.right.classList.remove(this.checked);
            this.right.classList.add(this.grouped);

            this.left = null;
            this.right = null;

            this.order();
        };

        MatchPair.prototype.order = function() {
            var cols = (utils.getLayout() === 'js-cols') ? true : false,
                left = (this.container || document).querySelectorAll('[data-column="left"]:not(.' + this.grouped + ')'),
                right = (this.container || document).querySelectorAll('[data-column="right"]:not(.' + this.grouped + ')'),
                header = (this.container || document).querySelectorAll('[data-column="header"]');

            for (var i = 0; i < left.length; i++) {
                left[i].dataset.orderno = self.orderno(i, 'left', cols);
            }

            for (var j = 0; j < right.length; j++) {
                right[j].dataset.orderno = self.orderno(j, 'right', cols);
            }

            for (var k = 0; k < header.length; k++) {
                header[k].dataset.orderno = self.orderno(k, 'header', cols);
            }

            trainingVM.validate();
        };

        MatchPair.prototype.setAnswered = function(parent) {
            if (!parent) {
                return;
            }

            var ID = parent.dataset.id || '',
                grouped = (ID) ? document.getElementById(ID) : null;

            if (!ID) {
                return;
            }

            parent.classList.add(this.answered);
            parent.classList.add('f-col-correct');

            grouped.classList.add(this.answered);
            grouped.classList.add('f-col-correct');
        };

        MatchPair.prototype.split = function(parent) {
            if (!parent) {
                return;
            }

            var ID = parent.dataset.id || '',
                grouped = (ID) ? document.getElementById(ID) : null;

            if (!ID) {
                return;
            }

            parent.classList.remove(this.grouped);
            parent.removeAttribute('data-id');
            this.setHeight(parent, 0);

            grouped.classList.remove(this.grouped);
            this.setHeight(grouped, 0);

            this.order();
        };

        MatchPair.prototype.update = function(target) {
            var parent = this.getParent(target.parentNode);

            if (!parent || !parent.classList || !parent.classList.contains('js-match-option') || parent.classList.contains(this.answered)) {
                return;
            }

            if (parent.classList.contains(this.grouped)) {
                this.split(parent);
            } else {
                this.visualize(parent);
            }
        };

        MatchPair.prototype.visualize = function(parent) {
            var node = document.getElementById(parent.id),
                column = (node && node.dataset) ? node.dataset.column : null;

            if (!column) {
                return;
            }

            if (node.classList && node.classList.contains(this.checked)) {
                this[column] = null;
                node.classList.remove(this.checked);
                return;
            }

            if (this[column]) {
                this[column].classList.remove(this.checked);
            }

            node.classList.add(this.checked);

            this[column] = node;

            if (this.left && this.right) {
                this.group();
            }
        };

        MatchPair.prototype.arrange = function(duration) {
            var ID = '',
                node,
                nodes,
                cols = (utils.getLayout() === 'js-cols') ? true : false,
                filter = cols ? '[data-column]' : '[data-column="right"], .match-option-grouped',
                isEnabled = taskVM.isEnabled();

            duration = duration || self.duration();

            if (!cols) {
                nodes = this.container.querySelectorAll('[data-column="left"]:not(.match-option-grouped)');

                if (nodes.length) {
                    node = nodes[0];
                    ID = node.id;
                    filter += ', [data-column="header"]';
                }

                if (ID) {
                    filter += ', [id="' + ID + '"]';

                    if (!this.left || this.left.id !== ID) {
                        this.ID = ID;
                        this.visualize(node);
                    }
                }

            } else if (this.ID) {
                node = document.getElementById(this.ID);

                if (node) {
                    this.visualize(node);
                }

                this.ID = '';
            }

            if (!iso || !isEnabled) {
                return;
            }

            iso.updateSortData();

            iso.arrange({
                filter: filter,
                transitionDuration: duration
            });
        }

        ko.bindingHandlers.taskMatchPair = {
            update: function(container) {
                var isEnabled = taskVM.isEnabled(),
                    delay = (isEnabled) ? 250 : 0,
                    duration = (isEnabled) ? self.duration() : 0,
                    counter = 0,
                    removeEventListeners = function() {
                        container.removeEventListener('touchend', arrangeMatchPair);
                        container.removeEventListener('click', arrangeMatchPair);
                        window.removeEventListener('resize', orderMatchPair);
                    };

                if (!container || !isEnabled) {
                    removeEventListeners();

                    if (iso) {
                        iso.destroy();
                    }

                    return;
                }

                function init(container, prop) {
                    iso = new Isotope(container, prop);

                    if (counter < 10) {
                        setTimeout(function() {
                            init(container, prop);
                        }, 50);
                        counter++;
                    }
                }

                function orderMatchPair() {
                    if (timeoutID) {
                        clearTimeout(timeoutID);
                    }

                    timeoutID = setTimeout(function() {
                        var ID, node, grouped,
                            selector = (isEnabled) ? '.match-option-grouped[data-column="left"]' : '.match-option-answered[data-column="left"]',
                            nodes = document.querySelectorAll(selector);

                        for (var i = 0; i < nodes.length; i++) {
                            node = nodes[i];
                            ID = (node && node.dataset.id) ? node.dataset.id : '';
                            grouped = (ID) ? document.getElementById(ID) : null;

                            if (!ID || !grouped) {
                                continue;
                            }

                            matchPair.resize(node, grouped);
                        }

                        if (isEnabled) {
                            matchPair.order();
                            matchPair.arrange(15);
                        }
                    }, delay);
                }

                function arrangeMatchPair(e) {
                    var target = e.target;

                    matchPair.update(target);

                    matchPair.arrange();

                    e.preventDefault();
                }

                var prop = {
                    elements: container.querySelectorAll('[data-orderno]'),
                    getSortData: {
                        orderno: '[data-orderno] parseInt'
                    },
                    sortBy: ['orderno'],
                    layoutMode: 'fitRows',
                    resizable: false,
                    transitionDuration: duration
                };

                setTimeout(function() {

                    matchPair = new MatchPair({container: container});

                    orderMatchPair();

                    init(container, prop);

                }, 0);

                ko.utils.domNodeDisposal.addDisposeCallback(container, removeEventListeners);

                window.addEventListener('resize', orderMatchPair);

                container.addEventListener('touchend', arrangeMatchPair);

                container.addEventListener('click', arrangeMatchPair);
            }
        };

        self.getAnswers = function(arr) {
            var node,
                answers = [],
                retry = (self.ACPV() === 0 || self.userAttempts() < self.ACPV() - 1) ? true : false;

            arr = arr || [];

            arr.forEach(function(a) {
                node = document.getElementById(a.id);

                if (!node || !node.dataset || !node.dataset.id) {
                    return;
                }

                if (retry) {
                    if (node.dataset.id !== a.correctAnswerId) {
                        matchPair.split(node);
                    } else {
                        matchPair.setAnswered(node);

                        answers.push({
                            name: a.id,
                            value: node.dataset.id,
                            orderno: node.dataset.orderno
                        });
                    }
                } else {
                    answers.push({
                        name: a.id,
                        value: node.dataset.id,
                        orderno: node.dataset.orderno
                    });
                }
            });

            answers.sort(function(a, b) {
                if (a.orderno < b.orderno) {
                    return -1;
                } else if(b.orderno < a.orderno) {
                    return 1;
                }
                return 0;
            });

            matchPair.arrange();

            if (retry) {
                self.updateAttempts(self.userAttempts());
            }

            trainingVM.validate();

            if (trainingVM.isValid() && dataContext.localStorage && userID) {
                (function () {
                    window.localStorage.removeItem('attempts-' + userID + '-' + entityVM.ID());
                    self.userAttempts(0)
                })();
            }

            return answers;
        };


        // Draggable version

        function MatchPairDraggable(options) {
            options = options || {};

            this.arr = options.arr || [];

            this.ID = options.ID || '';

            this.intervalID;

            this.container = (this.ID) ? document.getElementById('match-pair-container-' + this.ID) : document.body;

            this.paper = (this.ID && typeof window.Snap === 'function') ? window.Snap(document.getElementById('match-pair-svg-' + this.ID)) : null;

            this.paths = {};

            this.settings = this.getSettings(this.container);

            this.timeoutID;
        }

        function resizeDraggable() {
            matchPairDraggable.clearTimers();
            matchPairDraggable.updatePaths();
        }

        MatchPairDraggable.prototype.getSettings = function(container) {
            var node = container ? container.querySelector('.js-match-pair-colors') : null;

            return {
                width: (node) ? helpers.layout.nodeStyle(node, 'border-width') : '1px',
                default: (node) ? helpers.layout.nodeStyle(node, 'border-top-color') : '#222',
                correct: (node) ? helpers.layout.nodeStyle(node, 'border-right-color') : '#222',
                incorrect: (node) ? helpers.layout.nodeStyle(node, 'border-bottom-color') : '#222',
                answered: (node) ? helpers.layout.nodeStyle(node, 'border-left-color') : '#222'
            }
        };

        MatchPairDraggable.prototype.getOptions = function() {
            var _this = this;

            return {
                accepts: function(el, target) {
                    var ID = el.id,
                        targetID = target.id;

                    if (target.children && target.children.length) {
                        return false;
                    }

                    if (!ID || !targetID) {
                        return true;
                    }

                    if (targetID.indexOf('from-') === 0 && targetID.indexOf(ID) === -1) {
                        return false;
                    }

                    return true;
                },
                mirrorContainer: _this.container
            }
        };

        MatchPairDraggable.prototype.updatePaths = function(count) {
            count = count || 15;

            var _this = this,
                update = function() {
                    setTimeout(function() {

                        if (_this.paper) {
                            _this.paper.clear();
                        }

                        for (var i = 0; i < _this.arr.length; i++) {
                            _this.setFinalPath(_this.arr[i].id);
                        }

                    }, 15);

                    if (count--) {
                        update();
                    }
                };

            _this.timeoutID = setTimeout(update, 15);
        };

        MatchPairDraggable.prototype.updatePath = function(ID, from, to) {
            var _this = this;

            _this.path(ID, _this.container.getBoundingClientRect(), from.getBoundingClientRect(), to.getBoundingClientRect());
        };

        MatchPairDraggable.prototype.path = function(ID, wrap, from, to) {
            var _this = this,
                status = trainingVM.questionState(ID) || 'default',
                fromX = from.left + from.width/2 - parseInt(wrap.left),
                fromY = from.top + from.height/2 - parseInt(wrap.top),
                toX = to.left + to.width/2 - parseInt(wrap.left),
                toY = to.top + to.height/2 - parseInt(wrap.top);

            if (this.paths[ID]) {
                this.paths[ID].remove();
            }

            this.paths[ID] = _this.paper.path('M' + fromX + ' ' + fromY + ' L' + toX + ' ' + toY);
            this.paths[ID].attr({'stroke': _this.settings[status], 'stroke-width': _this.settings.width});
        };

        MatchPairDraggable.prototype.setPath = function(ID) {
            var _this = this,
                from = (ID) ? _this.container.querySelector('.js-from-' + ID) : null,
                to = (ID) ? _this.container.querySelector('.gu-mirror') : null;

            if (from && to) {
                _this.path(ID, _this.container.getBoundingClientRect(), from.getBoundingClientRect(), to.getBoundingClientRect());

                _this.intervalID = window.setInterval(function() {
                    _this.updatePath(ID, from, to);
                }, 15);

            } else {
                setTimeout(function() {
                    _this.setPath(ID);
                }, 15);
            }
        };

        MatchPairDraggable.prototype.setFinalPath = function(ID) {
            var _this = this;

            if (_this.intervalID) {
                window.clearInterval(_this.intervalID);
            }

            if (!_this.container) {
                return;
            }

            var from = (ID) ? _this.container.querySelector('.js-from-' + ID) : null,
                to = (ID) ? _this.container.querySelector('.js-to-' + ID) : null;

            if (from && to) {
                this.path(ID, _this.container.getBoundingClientRect(), from.getBoundingClientRect(), to.getBoundingClientRect());
            }
        };

        MatchPairDraggable.prototype.clearTimers = function() {
            var _this = this;

            if (_this.intervalID) {
                window.clearInterval(_this.intervalID);
            }

            if (_this.timeoutID) {
                window.clearTimeout(_this.timeoutID);
            }
        };

        MatchPairDraggable.prototype.bindEvents = function(drake) {
            var _this = this;

            if (!drake) {
                return;
            }

            drake.on('drag', function(node) {
                var ID = (node) ? node.id : null;

                _this.clearTimers();

                _this.setPath(ID);

            }).on('cancel', function() {

                _this.clearTimers();

                _this.updatePaths(1);

            }).on('drop', function(node) {
                var ID = (node) ? node.id : null;

                _this.clearTimers();

                _this.setFinalPath(ID);

                trainingVM.validate();
            });
        };

        MatchPairDraggable.prototype.reset = function(ID) {
            var node = document.getElementById(ID),
                from = document.getElementById('from-' + ID),
                cloned;

            if (!node || !from) {
                return;
            }

            cloned = node.cloneNode(true);

            node.parentNode.removeChild(node);

            from.appendChild(cloned);

            this.setFinalPath(ID);
        };

        MatchPairDraggable.prototype.initiate = function() {
            var _this = this,
                nodes = document.querySelectorAll('.js-drag-container'),
                containers = [];

            if (_this.paper) {
                _this.paper.clear();
            }

            for (var i = 0; i < nodes.length; i++) {
                containers.push(nodes[i]);
            }

            var drake = dragula(containers, _this.getOptions());

            _this.bindEvents(drake);
        };

        ko.bindingHandlers.taskMatchPairDraggable = {
            update: function (element, valueAccessor) {
                var content = entityVM.entityContent();

                if (timeoutDraggableID) {
                    clearTimeout(timeoutDraggableID);
                }

                ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                    window.removeEventListener('resize', resizeDraggable);
                });

                if (content.typeID !== 16) {
                    return;
                }

                timeoutDraggableID = setTimeout(function() {
                    var data = ko.unwrap(valueAccessor()),
                        userAnswers = new UserAnswers();

                    matchPairDraggable = new MatchPairDraggable({ID: data.ID, arr: data.arr});

                    if (!answers[data.ID] || (entityVM.canSubmitMultipleTimes() && userAnswers.isTaskPageAnswered(data.ID))) {
                        answers[data.ID] = [];
                    }

                    if (!trainingVM.answersEnabled()) {
                        matchPairDraggable.updatePaths();
                        return;
                    }

                    matchPairDraggable.initiate();

                    window.addEventListener('resize', resizeDraggable, false);

                }, 5);
            }
        };

        self.getAnswersDraggable = function(arr) {
            var ID,
                node,
                container,
                entityID = entityVM.ID();

            arr = arr || [];

            if (!answers[entityID].length) {
                for (var i = 0; i < arr.length; i++) {
                    ID = arr[i].correctAnswerId;
                    container = document.getElementById(ID);

                    if (!container) {
                        continue;
                    }

                    node = container.querySelector('.js-drag-item');

                    if (!node || !node.id) {
                        continue;
                    }

                    answers[entityID].push({
                        name: node.id,
                        value: ID
                    });
                }
            }

            self.validate(arr);

            return answers[entityID];
        };

        self.validate = function(arr) {
            var container;

            arr = arr || [];

            for (var i = 0; i < arr.length; i++) {
                container = document.getElementById(arr[i].correctAnswerId);

                if (!container) {
                    continue;
                }

                if (!container.querySelector('[id="' + arr[i].id + '"]')) {
                    matchPairDraggable.reset(arr[i].id);
                }
            }

            trainingVM.validate();
        }
    }

});

